"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerActions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useScrollHeight_1 = require("../../hooks/useScrollHeight");
const tools_1 = require("../../tools");
const Box_1 = require("../Box");
const Drawer_1 = require("../Drawer");
const StyledBox = tools_1.styled(Box_1.Box) `
  display: flex;
  flex-direction: row;

  button {
    background: rgba(127, 127, 127, 0.2);
    color: inherit;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    :hover {
      background: transparent;
    }
    font-size: 0.8rem;
    margin: 0;
    border-radius: none;
  }
`;
const DrawerActions = (props) => {
    const { setActionScrollHeight } = react_1.useContext(Drawer_1.DrawerContext);
    const divRef = react_1.useRef(null);
    const scrollHeight = useScrollHeight_1.useScrollHeight(divRef);
    react_1.useEffect(() => {
        setActionScrollHeight(scrollHeight);
    }, [scrollHeight, setActionScrollHeight]);
    return jsx_runtime_1.jsx(StyledBox, Object.assign({ ref: divRef }, props), void 0);
};
exports.DrawerActions = DrawerActions;
//# sourceMappingURL=index.js.map